import { createSelector } from 'reselect';
import { selectLoggedInUser } from './userSelector';
import { PERMISSION_TYPES } from '../../common/constants/CommonConstants';

const enrichWithEditPermissionCheck = (instanceList, loggedInUser) => {
  const { roleName: role } = loggedInUser;

  return instanceList.map((instance) => {
    const canCurrentUserEditEntity = role === PERMISSION_TYPES.ADMINISTRATOR;
    return {
      ...instance,
      canCurrentUserEditEntity,
    };
  });
};

export const allCustomObjects = (state) => state.customObject.customObjectData;

export const nonSystemCustomObjectsSelector = createSelector(
  allCustomObjects,
  (customObjects) => {
    return customObjects.filter(({ isSystem }) => {
      return !isSystem;
    });
  }
);

export const instancePartialListSelector = (apiName) =>
  createSelector(
    (state) => state.entityPartialList.list[apiName],
    selectLoggedInUser,
    enrichWithEditPermissionCheck
  );
